<template>
    <div class="step-final">
        <v-row>
            <v-col cols="12">
                <v-textarea 
                    :value="comment" 
                    @input="$emit('update:comment', $event)"
                    rows="5" 
                    no-resize 
                    outlined 
                    label="Comment" 
                    placeholder="Leave us a message (optional)" 
                    hide-details
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'WizardStepFinal',
    props: {
        comment: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="scss" scoped>
</style>

